import type { ChatBodyMessagesItem } from './chatBodyMessagesItem';

export type ChatBody = {
  /**
   * 최대 토큰 수
   * @minimum 1
   * @maximum 4096
   */
  max_tokens?: number;
  /** 대화 메시지 배열 */
  messages: ChatBodyMessagesItem[];
  /** 사용할 AI 모델 (auto, gemini-2.0-flash, llama2:latest 등) */
  model?: string;
  /** 스트리밍 응답 여부 */
  stream?: boolean;
  /** 시스템 프롬프트 */
  system_prompt?: string;
  /**
   * 응답의 창의성 조절 (0.0 ~ 1.0)
   * @minimum 0
   * @maximum 1
   */
  temperature?: number;
};
